document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('ProductFinderDrawer');
  if (!drawer) return;

  const locale = window.location.pathname.startsWith('/es') ? 'es' : 'pt';

const translations = {
  pt: {
    next: 'Seguinte',
    seeResults: 'Ver resultados',
    oneProduct: '1 produto disponível para as suas escolhas.',
    manyProducts: (count) => `${count} produtos disponíveis para as suas escolhas.`,
    noResults: 'Não encontrámos produtos com essa combinação. Tente ajustar os filtros.',
    resultsCount: (count) => `${count} produto${count === 1 ? '' : 's'} encontrado${count === 1 ? '' : 's'}`,
    viewProduct: 'Ver produto',
    chooseOptions: 'Escolhe as opções para veres os modelos disponíveis.',
    andSee: (count) => `e ver ${count} opções`,
    applySuggestion: 'Aplicar sugestão',
    increaseBudget: (value) => `Se aumentarmos o orçamento para ${value}€, existem mais opções disponíveis.`,
    increaseBudgetBtn: (value) => `Aumentar orçamento para ${value}€`,
    removeExtra: (extra) => `Se removermos o extra "${extra}", existem mais opções disponíveis.`,
    removeExtraBtn: (extra) => `Remover ${extra}`,
    changeAge: (lowerAge, currentAge) => `Se alterarmos a idade para ${lowerAge} anos em vez de ${currentAge}, existem mais opções disponíveis.`,
    changeAgeBtn: (lowerAge) => `Alterar idade para ${lowerAge} anos`,
    removeWeight: 'Se removermos o limite de peso, existem mais opções disponíveis.',
    removeWeightBtn: 'Remover filtro de peso',
    removeType: 'Se removermos o tipo de veículo escolhido, existem mais opções disponíveis.',
    removeTypeBtn: 'Remover tipo de veículo',
    removeSeats: 'Se removermos o filtro de lugares, existem mais opções disponíveis.',
    removeSeatsBtn: 'Remover filtro de lugares',
    removeBattery: 'Se removermos o filtro da bateria, existem mais opções disponíveis.',
    removeBatteryBtn: 'Remover filtro de bateria',
    removeControl: 'Se removermos o filtro de controlo parental, existem mais opções disponíveis.',
    removeControlBtn: 'Remover filtro de controlo parental',
    twoChanges: (first, second) => `Se ${first} e ${second}, existem mais opções disponíveis.`,
    extraLabels: {
      eva: 'rodas EVA',
      pele: 'assento em pele',
      plastico: 'rodas de plástico',
      musica: 'música',
      cinto: 'cinto de segurança',
      suspensao: 'suspensão',
      led: 'luzes LED'
    }
  },
  es: {
    next: 'Siguiente',
    seeResults: 'Ver resultados',
    oneProduct: '1 producto disponible para tus preferencias.',
    manyProducts: (count) => `${count} productos disponibles para tus preferencias.`,
    noResults: 'No hemos encontrado productos con esta combinación. Prueba a ajustar los filtros.',
    resultsCount: (count) => `${count} producto${count === 1 ? '' : 's'} encontrado${count === 1 ? '' : 's'}`,
    viewProduct: 'Ver producto',
    chooseOptions: 'Elige tus preferencias para ver los modelos disponibles.',
    andSee: (count) => `y ver ${count} opciones`,
    applySuggestion: 'Aplicar sugerencia',
    increaseBudget: (value) => `Si aumentamos el presupuesto a ${value}€, hay más opciones disponibles.`,
    increaseBudgetBtn: (value) => `Aumentar presupuesto a ${value}€`,
    removeExtra: (extra) => `Si quitamos el extra "${extra}", hay más opciones disponibles.`,
    removeExtraBtn: (extra) => `Quitar ${extra}`,
    changeAge: (lowerAge, currentAge) => `Si cambiamos la edad a ${lowerAge} años en vez de ${currentAge}, hay más opciones disponibles.`,
    changeAgeBtn: (lowerAge) => `Cambiar edad a ${lowerAge} años`,
    removeWeight: 'Si quitamos el límite de peso, hay más opciones disponibles.',
    removeWeightBtn: 'Quitar filtro de peso',
    removeType: 'Si quitamos el tipo de vehículo elegido, hay más opciones disponibles.',
    removeTypeBtn: 'Quitar tipo de vehículo',
    removeSeats: 'Si quitamos el filtro de plazas, hay más opciones disponibles.',
    removeSeatsBtn: 'Quitar filtro de plazas',
    removeBattery: 'Si quitamos el filtro de batería, hay más opciones disponibles.',
    removeBatteryBtn: 'Quitar filtro de batería',
    removeControl: 'Si quitamos el filtro de mando parental, hay más opciones disponibles.',
    removeControlBtn: 'Quitar filtro de mando parental',
    twoChanges: (first, second) => `Si ${first} y ${second}, hay más opciones disponibles.`,
    extraLabels: {
      eva: 'ruedas EVA',
      pele: 'asiento de cuero',
      plastico: 'ruedas de plástico',
      musica: 'música',
      cinto: 'cinturón de seguridad',
      suspensao: 'suspensión',
      led: 'luces LED'
    }
  }
};

const t = translations[locale];

  function getFinderSessionId() {
    let id = sessionStorage.getItem('finder_session_id');

    if (!id) {
      id = 'finder_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem('finder_session_id', id);
    }

    return id;
  }

function sendFinderEvent(eventType, data = {}) {
  const payload = {
    event_type: eventType,
    session_id: getFinderSessionId(),
    timestamp: new Date().toISOString(),

    page_url: window.location.href,
    page_path: window.location.pathname,
    referrer: document.referrer || '',

    device_type: getDeviceType(),
    locale: locale,

    utm_source: getUrlParam('utm_source'),
    utm_medium: getUrlParam('utm_medium'),
    utm_campaign: getUrlParam('utm_campaign'),
    utm_content: getUrlParam('utm_content'),
    utm_term: getUrlParam('utm_term'),

    ...data
  };

  console.log('[Product Finder Analytics]', payload);

  fetch('https://funtastic-finder.base44.app/functions/finderEvent', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': 'fl_finder_2026_R8mQ4vZp92LxT7nKa36WqYp5sD'
    },
    body: JSON.stringify(payload)
  }).catch((error) => {
    console.log('Finder tracking error:', error);
  });
}

function getDeviceType() {
  const width = window.innerWidth;

  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
}

function getUrlParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name) || '';
}

  const openButtons = document.querySelectorAll('[data-open-product-finder]');
  const closeButtons = drawer.querySelectorAll('[data-close-product-finder]');
  const budgetRange = drawer.querySelector('[data-budget-range]');
  const budgetValue = drawer.querySelector('[data-budget-value]');
  const nextButton = drawer.querySelector('[data-pf-next]');
  const backButton = drawer.querySelector('[data-pf-back]');
  const resetButton = drawer.querySelector('[data-pf-reset]');
  const progressFill = drawer.querySelector('.pf-progress__fill');
  const currentStepEl = drawer.querySelector('[data-pf-current-step]');
  const totalStepsEl = drawer.querySelector('[data-pf-total-steps]');
  const resultsWrap = drawer.querySelector('.pf-results');
  const resultsGrid = drawer.querySelector('[data-pf-results-grid]');
  const resultsCount = drawer.querySelector('[data-pf-results-count]');

  const stepOrder = ['budget', 'idade', 'lugares', 'controlo', 'tipo', 'bateria', 'peso', 'extras'];
  const stepElements = Array.from(drawer.querySelectorAll('.pf-step'));

  if (totalStepsEl) totalStepsEl.textContent = String(stepOrder.length);

  let currentStepIndex = 0;

  const budgetSteps = [80, 150, 200, 250, 300, 400, 700, 1300];

  const state = {
    budget: budgetSteps[7],
    idade: null,
    lugares: null,
    controlo: null,
    tipo: null,
    bateria: null,
    peso: null,
    extras: []
  };

  const products = getProductsFromDom();

  ensureLiveFeedbackMarkup();

  openButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');

      sendFinderEvent('finder_started');

      updateAvailability();
      updateLiveFeedback();
      renderStep();
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

if (budgetRange) {
  function updateBudgetFromRange(track = true) {
    let index = parseInt(budgetRange.value, 10);

    if (Number.isNaN(index)) index = 7;
    if (index < 0) index = 0;
    if (index > budgetSteps.length - 1) index = budgetSteps.length - 1;

    const selectedBudget = Number(budgetSteps[index]);

    state.budget = selectedBudget;

    if (budgetValue) {
      budgetValue.textContent = `${selectedBudget}€`;
    }

    if (track) {
      sendFinderEvent('finder_step_answered', getTrackingPayload('budget', selectedBudget));
    }

    updateAvailability();
    updateLiveFeedback();
  }

  budgetRange.addEventListener('input', () => updateBudgetFromRange(true));
  budgetRange.addEventListener('change', () => updateBudgetFromRange(true));

  updateBudgetFromRange(false);
}

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      if (resultsWrap && resultsWrap.hidden === false) return;

      if (currentStepIndex < stepOrder.length - 1) {
        currentStepIndex += 1;
        renderStep();
      } else {
        renderResults();
      }
    });
  }

  if (backButton) {
    backButton.addEventListener('click', () => {
      if (resultsWrap && resultsWrap.hidden === false) {
        resultsWrap.hidden = true;
        renderStep();
        updateLiveFeedback();
        return;
      }

      if (currentStepIndex > 0) {
        currentStepIndex -= 1;
        renderStep();
      }
    });
  }

  if (resetButton) {
    resetButton.addEventListener('click', () => {
      sendFinderEvent('finder_reset', {
        budget: state.budget,
        idade: state.idade,
        lugares: state.lugares,
        controlo: state.controlo,
        tipo: state.tipo,
        bateria: state.bateria,
        peso: state.peso,
        extras: state.extras
      });

      state.budget = budgetSteps[7];
      state.idade = null;
      state.lugares = null;
      state.controlo = null;
      state.tipo = null;
      state.bateria = null;
      state.peso = null;
      state.extras = [];

      currentStepIndex = 0;

      if (budgetRange) budgetRange.value = '7';
      if (budgetValue) budgetValue.textContent = '1300€';
      if (resultsWrap) resultsWrap.hidden = true;

      drawer.querySelectorAll('.pf-option').forEach((el) => {
        el.classList.remove('is-selected', 'is-disabled');
      });

      updateAvailability();
      updateLiveFeedback();
      renderStep();
    });
  }

drawer.querySelectorAll('button[data-filter-key]').forEach((button) => {
  button.addEventListener('click', () => {
    if (button.classList.contains('is-disabled')) return;

    const key = button.dataset.filterKey;
    const value = button.dataset.filterValue;

    state[key] = value === '' ? null : value;

    sendFinderEvent('finder_step_answered', getTrackingPayload(key, state[key]));

    drawer.querySelectorAll(`button[data-filter-key="${key}"]`).forEach((el) => {
      el.classList.remove('is-selected');
    });

    button.classList.add('is-selected');

    updateAvailability();
    updateLiveFeedback();
  });
});

  drawer.querySelectorAll('[data-extra-key]').forEach((button) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('is-disabled')) return;

      const key = button.dataset.extraKey;
      const exists = state.extras.includes(key);

      if (exists) {
        state.extras = state.extras.filter((item) => item !== key);
        button.classList.remove('is-selected');
      } else {
        state.extras.push(key);
        button.classList.add('is-selected');
      }

      sendFinderEvent('finder_step_answered', getTrackingPayload('extras', state.extras));

      updateAvailability();
      updateLiveFeedback();
    });
  });

function closeDrawer() {
  const hasResultsVisible = resultsWrap && resultsWrap.hidden === false;

  if (!hasResultsVisible) {
    sendFinderEvent('finder_abandoned', {
      abandonment_step: stepOrder[currentStepIndex],
      abandonment_step_order: currentStepIndex + 1,
      abandonmentStep: stepOrder[currentStepIndex],
      abandonmentStepOrder: currentStepIndex + 1,

      budget: state.budget,
      idade: state.idade,
      lugares: state.lugares,
      controlo: state.controlo,
      tipo: state.tipo,
      bateria: state.bateria,
      peso: state.peso,
      extras: state.extras,
      results_viewed: false
    });
  }

  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
}

  function renderStep() {
    if (resultsWrap) resultsWrap.hidden = true;

    const activeStep = stepOrder[currentStepIndex];

    stepElements.forEach((el) => {
      el.classList.toggle('is-active', el.dataset.step === activeStep);
    });

    if (currentStepEl) currentStepEl.textContent = String(currentStepIndex + 1);
    if (progressFill) progressFill.style.width = `${((currentStepIndex + 1) / stepOrder.length) * 100}%`;

    if (backButton) backButton.disabled = currentStepIndex === 0;
    if (nextButton) nextButton.textContent = currentStepIndex === stepOrder.length - 1 ? t.seeResults : t.next;

    updateLiveFeedback();
  }

 function getBaseFilteredProducts(testState = state) {
  const selectedBudget = Number(testState.budget || budgetSteps[budgetSteps.length - 1]);

  return products.filter((product) => {
    const productPrice = Number(product.price || 0);

    if (selectedBudget && productPrice > selectedBudget) {
      return false;
    }

    if (testState.idade) {
      if (!product.idade) return false;
      if (Number(product.idade) < Number(testState.idade)) return false;
    }

    if (testState.lugares) {
      if (!product.lugares) return false;
      if (String(product.lugares) !== String(testState.lugares)) return false;
    }

    if (testState.controlo !== null && testState.controlo !== undefined && testState.controlo !== '') {
      if (product.controlo === null || product.controlo === undefined) return false;
      if (String(product.controlo) !== String(testState.controlo)) return false;
    }

    if (testState.tipo) {
      if (!product.tipo) return false;
      if (product.tipo !== testState.tipo) return false;
    }

    if (testState.bateria) {
      if (!product.bateria) return false;
      if (product.bateria !== testState.bateria) return false;
    }

    if (testState.peso) {
      if (!product.peso) return false;
      if (Number(product.peso) < Number(testState.peso)) return false;
    }

    return true;
  });
}

  function getRecommendedProducts(testState = state) {
    return getBaseFilteredProducts(testState)
      .filter((product) => productMatchesAllExtras(product, testState.extras || []));
  }

  function countProductsForState(testState = state) {
    return getRecommendedProducts(testState).length;
  }

  function updateAvailability() {
    const keys = ['idade', 'lugares', 'controlo', 'tipo', 'bateria', 'peso'];

    keys.forEach((key) => {
      const options = drawer.querySelectorAll(`[data-filter-key="${key}"]`);

      options.forEach((option) => {
        const testValue = option.dataset.filterValue;

        if (testValue === '') {
          option.classList.remove('is-disabled');
          return;
        }

        const tempState = cloneFinderState(state);
        tempState[key] = testValue;

        const hasMatch = getRecommendedProducts(tempState).length > 0;

        option.classList.toggle('is-disabled', !hasMatch);

        if (!hasMatch && state[key] === testValue) {
          state[key] = null;
          option.classList.remove('is-selected');
        }
      });
    });

    drawer.querySelectorAll('[data-extra-key]').forEach((option) => {
      const extraKey = option.dataset.extraKey;

      const tempState = cloneFinderState(state);

      if (!tempState.extras.includes(extraKey)) {
        tempState.extras.push(extraKey);
      }

      const hasMatch = getRecommendedProducts(tempState).length > 0;
      const isAlreadySelected = state.extras.includes(extraKey);

      option.classList.toggle('is-disabled', !hasMatch && !isAlreadySelected);

      if (!hasMatch && isAlreadySelected) {
        state.extras = state.extras.filter((item) => item !== extraKey);
        option.classList.remove('is-selected');
      }
    });
  }

  function cloneFinderState(source = state) {
    return {
      ...source,
      extras: Array.isArray(source.extras) ? [...source.extras] : []
    };
  }

  function getNextBudgetValue(currentBudget) {
    if (!currentBudget) return null;

    const currentIndex = budgetSteps.indexOf(Number(currentBudget));

    if (currentIndex === -1 || currentIndex >= budgetSteps.length - 1) {
      return null;
    }

    return budgetSteps[currentIndex + 1];
  }

  function getUsefulSuggestion(currentState = state) {
    const currentCount = countProductsForState(currentState);

    if (currentCount >= 4) return null;

    const suggestions = [];

    function testSuggestion(label, buttonText, changes, priority) {
      const testState = cloneFinderState(currentState);

      Object.keys(changes).forEach((key) => {
        testState[key] = changes[key];
      });

      const newCount = countProductsForState(testState);

      if (newCount > currentCount) {
        suggestions.push({
          label,
          buttonText,
          changes,
          count: newCount,
          gain: newCount - currentCount,
          priority
        });
      }
    }

    const nextBudget = getNextBudgetValue(currentState.budget);

    if (nextBudget) {
      testSuggestion(
       t.increaseBudget(nextBudget) ,
        t.increaseBudgetBtn(nextBudget),
        { budget: nextBudget },
        1
      );
    }

    if (Array.isArray(currentState.extras) && currentState.extras.length > 0) {
      currentState.extras.forEach((extra) => {
        const newExtras = currentState.extras.filter((item) => item !== extra);

        testSuggestion(
          t.removeExtra(getExtraLabel(extra)),
          t.removeExtraBtn(getExtraLabel(extra)),
          { extras: newExtras },
          2
        );
      });
    }

    if (currentState.idade) {
      const currentAge = Number(currentState.idade);
      const lowerAge = currentAge - 1;

      if (lowerAge >= 3) {
        testSuggestion(
          t.changeAge(lowerAge, currentAge),
          t.changeAgeBtn(lowerAge),
          { idade: lowerAge },
          3
        );
      }
    }

    if (currentState.peso) {
      testSuggestion(
        `Se removermos o limite de peso, existem mais opções disponíveis.`,
        `Remover filtro de peso`,
        { peso: null },
        4
      );
    }

    if (currentState.tipo) {
      testSuggestion(
        `Se removermos o tipo de veículo escolhido, existem mais opções disponíveis.`,
        `Remover tipo de veículo`,
        { tipo: null },
        5
      );
    }

    if (currentState.lugares) {
      testSuggestion(
        `Se removermos o filtro de lugares, existem mais opções disponíveis.`,
        `Remover filtro de lugares`,
        { lugares: null },
        6
      );
    }

    if (currentState.bateria) {
      testSuggestion(
        `Se removermos o filtro da bateria, existem mais opções disponíveis.`,
        `Remover filtro de bateria`,
        { bateria: null },
        7
      );
    }

    if (currentState.controlo !== null && currentState.controlo !== undefined) {
      testSuggestion(
        `Se removermos o filtro de controlo parental, existem mais opções disponíveis.`,
        `Remover filtro de controlo parental`,
        { controlo: null },
        8
      );
    }

    const twoChangeSuggestions = getTwoChangeSuggestions(currentState, currentCount);
    suggestions.push(...twoChangeSuggestions);

    if (!suggestions.length) return null;

    suggestions.sort((a, b) => {
      const aReachesGoal = a.count >= 4 ? 1 : 0;
      const bReachesGoal = b.count >= 4 ? 1 : 0;

      if (aReachesGoal !== bReachesGoal) {
        return bReachesGoal - aReachesGoal;
      }

      if (a.priority !== b.priority) {
        return a.priority - b.priority;
      }

      return b.count - a.count;
    });

    return suggestions[0];
  }

  function getTwoChangeSuggestions(currentState, currentCount) {
    const suggestions = [];
    const possibleChanges = [];

    const nextBudget = getNextBudgetValue(currentState.budget);

    if (nextBudget) {
      possibleChanges.push({
        changes: { budget: nextBudget },
        text: `aumentarmos o orçamento para ${nextBudget}€`,
        priority: 1
      });
    }

    if (Array.isArray(currentState.extras) && currentState.extras.length > 0) {
      currentState.extras.forEach((extra) => {
        possibleChanges.push({
          changes: {
            extras: currentState.extras.filter((item) => item !== extra)
          },
          text: `removermos o extra "${getExtraLabel(extra)}"`,
          priority: 2
        });
      });
    }

    if (currentState.idade) {
      const currentAge = Number(currentState.idade);
      const lowerAge = currentAge - 1;

      if (lowerAge >= 3) {
        possibleChanges.push({
          changes: { idade: lowerAge },
          text: `alterarmos a idade para ${lowerAge} anos`,
          priority: 3
        });
      }
    }

    if (currentState.peso) {
      possibleChanges.push({
        changes: { peso: null },
        text: `removermos o limite de peso`,
        priority: 4
      });
    }

    if (currentState.tipo) {
      possibleChanges.push({
        changes: { tipo: null },
        text: `removermos o tipo de veículo`,
        priority: 5
      });
    }

    if (currentState.lugares) {
      possibleChanges.push({
        changes: { lugares: null },
        text: `removermos o filtro de lugares`,
        priority: 6
      });
    }

    if (currentState.bateria) {
      possibleChanges.push({
        changes: { bateria: null },
        text: `removermos o filtro da bateria`,
        priority: 7
      });
    }

    if (currentState.controlo !== null && currentState.controlo !== undefined) {
      possibleChanges.push({
        changes: { controlo: null },
        text: `removermos o filtro de controlo parental`,
        priority: 8
      });
    }

    for (let i = 0; i < possibleChanges.length; i++) {
      for (let j = i + 1; j < possibleChanges.length; j++) {
        const first = possibleChanges[i];
        const second = possibleChanges[j];

        const testState = cloneFinderState(currentState);

        Object.assign(testState, first.changes);
        Object.assign(testState, second.changes);

        const newCount = countProductsForState(testState);

        if (newCount > currentCount) {
          suggestions.push({
            label: `Se ${first.text} e ${second.text}, existem mais opções disponíveis.`,
            buttonText: `Aplicar sugestão`,
            changes: {
              ...first.changes,
              ...second.changes
            },
            count: newCount,
            gain: newCount - currentCount,
            priority: first.priority + second.priority + 10
          });
        }
      }
    }

    return suggestions;
  }

function getExtraLabel(extra) {
  return t.extraLabels[extra] || extra;
}

  function updateLiveFeedback() {
    const countEl = drawer.querySelector('#pf-live-count');
    const suggestionEl = drawer.querySelector('#pf-smart-suggestion');

    if (!countEl || !suggestionEl) return;

    const count = countProductsForState(state);

      if (count === 1) {
      countEl.textContent = t.oneProduct;
    } else {
      countEl.textContent = t.manyProducts(count);
    }

    suggestionEl.hidden = true;
    suggestionEl.innerHTML = '';

    const suggestion = getUsefulSuggestion(state);

    if (!suggestion) return;

    suggestionEl.hidden = false;
    suggestionEl.innerHTML = `
      <p>${suggestion.label}</p>
      <button type="button" class="pf-apply-suggestion">
        ${suggestion.buttonText} ${t.andSee(suggestion.count)}
      </button>
    `;

    const button = suggestionEl.querySelector('.pf-apply-suggestion');

    if (button) {
      button.addEventListener('click', function () {
        applyFinderSuggestion(suggestion);
      });
    }
  }

  function applyFinderSuggestion(suggestion) {
    if (!suggestion || !suggestion.changes) return;

    const previousCount = countProductsForState(state);

    Object.keys(suggestion.changes).forEach((key) => {
      state[key] = suggestion.changes[key];
    });

    syncFinderUIWithState();

    updateAvailability();
    updateLiveFeedback();
    renderResults();

    sendFinderEvent('finder_suggestion_applied', {
      suggestion_label: suggestion.label,
      suggestion_changes: suggestion.changes,
      previous_count: previousCount,
      new_count: suggestion.count
    });
  }

function syncFinderUIWithState() {
  drawer.querySelectorAll('button[data-filter-key]').forEach((button) => {
    const key = button.dataset.filterKey;
    const value = button.dataset.filterValue || null;

    let currentValue = state[key];

    if (currentValue === true) currentValue = 'true';
    if (currentValue === false) currentValue = 'false';
    if (currentValue !== null && currentValue !== undefined) {
      currentValue = String(currentValue);
    }

    button.classList.toggle('is-selected', currentValue === value);
  });

  if (budgetRange && state.budget) {
    const budgetIndex = budgetSteps.indexOf(Number(state.budget));

    if (budgetIndex !== -1) {
      budgetRange.value = String(budgetIndex);
    }
  }

  if (budgetValue && state.budget) {
    budgetValue.textContent = `${state.budget}€`;
  }

  drawer.querySelectorAll('[data-extra-key]').forEach((button) => {
    const extra = button.dataset.extraKey;
    const isActive = Array.isArray(state.extras) && state.extras.includes(extra);

    button.classList.toggle('is-selected', isActive);
  });
}

  function renderResults() {
    const filtered = getRecommendedProducts()
      .map((product) => ({
        ...product,
        score: getExtraScore(product, state.extras)
      }))
      .sort((a, b) => {
        if (b.score !== a.score) return b.score - a.score;
        return a.price - b.price;
      });

    if (resultsGrid) resultsGrid.innerHTML = '';

    if (!filtered.length) {
sendFinderEvent('finder_results_viewed', {
  budget: state.budget,
  idade: state.idade,
  lugares: state.lugares,
  controlo: state.controlo,
  tipo: state.tipo,
  bateria: state.bateria,
  peso: state.peso,
  extras: state.extras,

  results_count: 0,
  resultsCount: 0,

  top_products: [],
  topProducts: [],
  topProductHandles: [],

  had_zero_results: true,
  hadZeroResults: true
});

      if (resultsWrap) resultsWrap.hidden = false;
      if (resultsCount) resultsCount.textContent = t.noResults;

      stepElements.forEach((el) => el.classList.remove('is-active'));
      if (nextButton) nextButton.textContent = t.seeResults;

      updateLiveFeedback();
      return;
    }

    const sliced = filtered.slice(0, 6);

    sendFinderEvent('finder_results_viewed', {
      budget: state.budget,
      idade: state.idade,
      lugares: state.lugares,
      controlo: state.controlo,
      tipo: state.tipo,
      bateria: state.bateria,
      peso: state.peso,
      extras: state.extras,
      results_count: filtered.length,
top_products: sliced.map((product) => ({
  handle: getProductHandle(product.url),
  title: product.title,
  url: product.url,
  price: product.price
})),

topProducts: sliced.map((product) => getProductHandle(product.url)),
topProductHandles: sliced.map((product) => getProductHandle(product.url))
    });

    if (resultsCount) {
      resultsCount.textContent = t.resultsCount(filtered.length);
    }

sliced.forEach((product) => {
  const card = document.createElement('article');
  card.className = 'pf-product-card';

  card.innerHTML = `
    <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}">
    <div>
      <h4 class="pf-product-card__title">${escapeHtml(product.title)}</h4>
      <p class="pf-product-card__price">${formatMoney(product.price)}</p>
      <a class="pf-product-card__link" href="${escapeHtml(product.url)}">${t.viewProduct}</a>
    </div>
  `;

  const productLink = card.querySelector('.pf-product-card__link');

  if (productLink) {
    productLink.addEventListener('click', () => {
      const productHandle = getProductHandle(product.url);

      sendFinderEvent('finder_product_clicked', {
        budget: state.budget,
        idade: state.idade,
        lugares: state.lugares,
        controlo: state.controlo,
        tipo: state.tipo,
        bateria: state.bateria,
        peso: state.peso,
        extras: state.extras,

        product_handle: productHandle,
        product_title: product.title,
        product_url: product.url,
        product_price: product.price,

        productHandle: productHandle,
        productTitle: product.title,
        productUrl: product.url,
        productPrice: product.price
      });
    });
  }

  if (resultsGrid) resultsGrid.appendChild(card);
});

    stepElements.forEach((el) => el.classList.remove('is-active'));

    if (resultsWrap) resultsWrap.hidden = false;
    if (currentStepEl) currentStepEl.textContent = String(stepOrder.length);
    if (progressFill) progressFill.style.width = '100%';
    if (nextButton) nextButton.textContent = t.seeResults;

    updateLiveFeedback();
  }

  function productMatchesAllExtras(product, extras) {
    if (!extras.length) return true;

    return extras.every((extra) => {
      if (extra === 'eva') return product.eva === true;
      if (extra === 'pele') return product.pele === true;
      if (extra === 'plastico') return product.plastico === true;
      if (extra === 'musica') return product.musica === true;
      if (extra === 'cinto') return product.cinto === true;
      if (extra === 'suspensao') return product.suspensao === true;
      if (extra === 'led') return product.led === true;
      return true;
    });
  }

  function getExtraScore(product, extras) {
    if (!extras.length) return 0;

    let score = 0;

    extras.forEach((extra) => {
      if (extra === 'eva' && product.eva) score += 3;
      if (extra === 'pele' && product.pele) score += 3;
      if (extra === 'plastico' && product.plastico) score += 2;
      if (extra === 'musica' && product.musica) score += 2;
      if (extra === 'cinto' && product.cinto) score += 1;
      if (extra === 'suspensao' && product.suspensao) score += 2;
      if (extra === 'led' && product.led) score += 1;
    });

    return score;
  }

  function getProductsFromDom() {
    const el = document.getElementById('ProductFinderData');
    if (!el) return [];

    try {
      const raw = JSON.parse(el.textContent);

      return raw
        .map((product) => ({
          title: product.title || '',
          url: product.url || '#',
          price: Number(product.price || 0),
          image: product.image || '',
          idade: normalizeText(product.idade),
          lugares: normalizeText(product.lugares),
          controlo: normalizeBooleanText(product.controlo),
          tipo: normalizeText(product.tipo),
          bateria: normalizeText(product.bateria),
          peso: normalizeText(product.peso),
          eva: normalizeBoolean(product.eva),
          pele: normalizeBoolean(product.pele),
          plastico: normalizeBoolean(product.plastico),
          musica: normalizeBoolean(product.musica),
          cinto: normalizeBoolean(product.cinto),
          suspensao: normalizeBoolean(product.suspensao),
          led: normalizeBoolean(product.led)
        }))
        .filter((item) => {
          return item.title && item.url && item.price >= 0;
        });
    } catch (error) {
      console.error('Erro ao ler ProductFinderData', error);
      return [];
    }
  }

  function normalizeText(value) {
    if (value === null || value === undefined || value === '') return null;
    return String(value).trim().toLowerCase();
  }

  function normalizeBoolean(value) {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    return false;
  }

  function normalizeBooleanText(value) {
    if (value === true || value === 'true') return 'true';
    if (value === false || value === 'false') return 'false';
    return null;
  }

  function formatMoney(price) {
    return new Intl.NumberFormat(locale === 'es' ? 'es-ES' : 'pt-PT', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  }

  function getProductHandle(url) {
  if (!url) return '';

  try {
    const cleanUrl = url.split('?')[0].split('#')[0];
    const parts = cleanUrl.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
  } catch (error) {
    return '';
  }
}

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

 function getTrackingPayload(stepName, stepValue) {
  const order = stepOrder.indexOf(stepName) + 1;

  return {
    step_name: stepName,
    step_value: stepValue,
    step_order: order,

    stepName: stepName,
    stepValue: stepValue,
    stepOrder: order,

    budget: state.budget,
    idade: state.idade,
    lugares: state.lugares,
    controlo: state.controlo,
    tipo: state.tipo,
    bateria: state.bateria,
    peso: state.peso,
    extras: state.extras
  };
}

  function ensureLiveFeedbackMarkup() {
    if (drawer.querySelector('#pf-live-feedback')) return;

    const feedback = document.createElement('div');
    feedback.className = 'pf-live-feedback';
    feedback.id = 'pf-live-feedback';

    feedback.innerHTML = `
      <p id="pf-live-count">${t.chooseOptions}</p>
      <div id="pf-smart-suggestion" class="pf-smart-suggestion" hidden></div>
    `;

    if (resultsWrap && resultsWrap.parentNode) {
      resultsWrap.parentNode.insertBefore(feedback, resultsWrap);
    } else {
      drawer.appendChild(feedback);
    }
  }

  updateAvailability();
  updateLiveFeedback();
  renderStep();
});